import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import { ErrorModalComponent, IErrorModalParameters } from './error-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorModalService {
  constructor(private _ngbModal: NgbModal) {}

  public open(error: HttpErrorResponse): Observable<NgbModalRef> {
    const modalRef = this._ngbModal.open(ErrorModalComponent, { size: 'lg' });
    const instance = modalRef.componentInstance;
    instance.parameters = {
      error,
    } as IErrorModalParameters;
    return of(modalRef);
  }
}
